import { Slide, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ToastifyContainer = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <ToastContainer {...props} transition={Slide} />
)

export default ToastifyContainer
